import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import { previewHistoryBatch } from '../../../../store/extensions';
import BackdropHlsAdjustmentSlider from './BackdropHlsAdjustmentSlider';

const BackdropHlsAdjustmentLightnessListItem = (props) => {
    const { updateBackgroundSettings, maxHlsAdjustmentLightness, hlsAdjustmentLightness } = props;

    const onLightnessChange = (value) => {
        previewHistoryBatch.start()
        updateBackgroundSettings({ hlsAdjustment: { lightness: value } });
    }

    return (
        <BackdropHlsAdjustmentSlider
            title='Lightness'
            value={hlsAdjustmentLightness}
            min={0}
            max={maxHlsAdjustmentLightness * 100}
            step={0.1}
            onValueChange={onLightnessChange}
            hideArrows
        />
    );
};

const mapStateToProps = (state) => {
    const hlsAdjustmentLightness = state.createPreview.present.videoSettings.background.hlsAdjustment.lightness;
    const { maxHlsAdjustmentLightness } = state.create.maxValues;

    return {
        hlsAdjustmentLightness,
        maxHlsAdjustmentLightness
    }
}

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackdropHlsAdjustmentLightnessListItem);